<template>
  <div class="chain-container">
    <template v-for="(chall, index) in getChallenges()" :key="chall.id">
      <span
        v-if="index"
        class="chain-link"
        :class="{powered: solved(chall.unlocked_by)}"
        aria-hidden="true"
      />
      <ChallengeInfo :challenge="chall" />
    </template>
  </div>
</template>

<script>
import ChallengeInfo from '@/components/ChallengeInfo.vue'
export default {
    components: {
        ChallengeInfo,
    },
    props: ['challenge'],
    methods: {
        getChallenges () {
            let c = this.challenge
            const challenges = [c]
            while (c.unlocks) {
                c = this.$store.state.challenges[c.unlocks]
                challenges.push(c)
            }
            return challenges
        },
        solved (id) {
            return !!this.$store.state.team && id in this.$store.state.team.solves
        },
    },
}
</script>

<style lang="scss" scoped>
.chain-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .challenge {
        margin-right: 0;
    }

    .challenge:last-child {
        margin-right: $challenge-spacing;
    }
}

// Redstone dust from one link of the chain to the next, powered once the
// link before it is solved.
.chain-link {
    position: relative;
    width: $challenge-chain-arrow-depth;
    height: 6px;
    margin: 0 $challenge-chain-spacing;
    background: repeating-linear-gradient(90deg, #7a0b0b 0 3px, #4c0000 3px 6px);

    &::after {
        content: "";
        position: absolute;
        right: -6px;
        top: -5px;
        border: 8px solid transparent;
        border-right: 0;
        border-left-color: #7a0b0b;
    }

    &.powered {
        background: repeating-linear-gradient(90deg, #ff3300 0 3px, #c81e00 3px 6px);
        box-shadow: 0 0 6px rgba(255, 51, 0, 0.6);

        &::after {
            border-left-color: #ff3300;
        }
    }
}
</style>
